<app-phx-data-table #grd [columns]="columns" [configuration]="dataTableConfiguration" [dataSourceUrl]="dataSourceUrl"
 [dataSourceParams]="oDataParams" [componentName]="dataGridComponentName" (rowClick)="onRowClick($event)"
 exportFileName="Documents" (contextMenuOpenTab)="onContextMenuOpenTab($event)">
	<div *dxTemplate="let document of 'actionCellTemplate'">
		<a type="button" class="btn btn-default btn-material" *ngIf="document.data.PdfDocumentPublicId !== '00000000-0000-0000-0000-000000000000'"
		 (click)="openDocument(document.data.PublicId)"><i class="material-icons">remove_red_eye</i></a>
		<button type="button" class="btn btn-default btn-material" (click)="documentDelete(document.data)" title="Delete" *ngIf="canDeleteDocument(document.data)"><i
			 class="material-icons">delete</i></button>
	</div>
</app-phx-data-table>